<template>
  <ScModal
    class="otp-modal"
    :show="true"
  >
    <div class="modal-header">
      <h5 class="modal-title">
        SMS Doğrulama
      </h5>
      <button
        type="button"
        class="close"
        @click="close"
      >
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <img
        class="icon-otpMessage"
        src="https://cdn.dsmcdn.com/seller-center/onboarding/images/otpMessage.svg"
        alt="otp-message"
      >
      <span class="info-text">
        Lütfen telefonunuza SMS yoluyla gelen 5 haneli kodu aşağıdaki alana giriniz.
      </span>
      <OtpInputWrapper
        :key="key"
        class="otp-input-wrapper"
        :disabled="!remainingTime"
        @complete="onOtpComplete"
      />
      <span class="remaining-time">
        {{ remainingTime }} sn
      </span>
      <ScButton
        class="submit-btn"
        variant="success"
        @click="submit"
        :disabled="!otp || !remainingTime"
      >
        Kodu Onayla
      </ScButton>
      <InvisibleRecaptcha
        @callback="onCaptcha"
        :site-key="siteKey"
        class="btn btn-lg resend-btn btn-mp-link"
        variant="link"
        id="otp-resend"
      >
        Kodu Tekrar Gönder
      </InvisibleRecaptcha>
    </div>
  </ScModal>
</template>

<script>

import ScModal from '@trendyol/sc-ui-kit/ScModal';
import ScButton from '@trendyol/sc-ui-kit/ScButton';
import RecaptchaService from '@/services/RecaptchaService';
import OtpInputWrapper from './OtpInputWrapper/Index';
import InvisibleRecaptcha from '@/components/Shared/InvisibleRecaptcha';

export default {
  name: 'OtpModal',
  components: { InvisibleRecaptcha, ScModal, OtpInputWrapper, ScButton },
  props: {
    otpRemainingTimeObject: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      otp: '',
      remainingTime: 3,
      remainingTimeInterval: null,
      key: (new Date()).getTime(),
      siteKey: RecaptchaService.getInvisibleSiteKey(),
    };
  },
  watch: {
    otpRemainingTimeObject: {
      handler (newValue) {
        if (newValue && typeof newValue.seconds === 'number') {
          this.remainingTime = newValue.seconds;
          this.otp = '';
          this.key = (new Date()).getTime();
          this.setRemainingTimeInterval();
        }
      },
      immediate: true,
    },
  },
  created () {
    this.setRemainingTimeInterval();
  },
  methods: {
    onCaptcha (captchaPayload) {
      this.$emit('resend', captchaPayload);
    },
    setRemainingTimeInterval () {
      clearInterval(this.remainingTimeInterval);

      this.remainingTimeInterval = setInterval(function () {
        this.remainingTime -= 1;
        if (this.remainingTime === 0) {
          clearInterval(this.remainingTimeInterval);
          this.remainingTimeInterval = null;
        }
      }.bind(this), 1000);
    },
    onOtpComplete (otp) {
      this.otp = otp;
      this.submit();
    },
    submit () {
      this.$emit('submit', this.otp);
    },
    close () {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.otp-modal{
  position: fixed;
  width: 100vw;
  height: 100vh;

  &::v-deep .modal-dialog{
    width: calc(100% - 1rem);
  }
  .modal-header{
    padding: 30px;
    .modal-title{
      font-size: 20px;
      font-weight: 500;
      color: #273142;
    }
  }
  .modal-body{
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .icon-otpMessage{
      height: 125px;
    }
    .info-text{
      margin-top: 24px;
      font-size: 14px;
      color: #6e7787;
    }
    .otp-input-wrapper{
      margin-top: 30px;
    }
    .remaining-time{
      margin: 18px 0 20px 0;
      color: #0bc15c;
      font-size: 14px;
      font-weight: 500;
    }
    .submit-btn{
      width: 100%;
      &:disabled{
        cursor: not-allowed;
      }
    }
    .resend-btn{
      margin-bottom: 30px;
      font-size: 14px;
      font-weight: normal;
      text-align: center;
      color: #273142;
      text-decoration: underline;
    }
  }
}
</style>
